import type { ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';
import { AuthProvider } from './AuthProvider';
import { ThemeProvider } from './ThemeProvider';
import { EventProvider } from '@/state/event-context';

// Ordem: Query (cache) → Auth (token) → Theme (marca DB-driven) → Event (contexto
// de evento ativo, scoped, depende de Query+Auth).
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <AuthProvider>
        <ThemeProvider>
          <EventProvider>{children}</EventProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryProvider>
  );
}
